import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Facebook, Twitter, MapPin, Phone, Mail, ShieldCheck, ChefHat } from "lucide-react";
import { useContent } from "../context/ContentContext";
import { trackPhoneClick } from "../lib/analytics";
import logoLight from "../assets/logo.png";

export function Footer() {
  const { content } = useContent();
  const f = content?.footer || {};
  const explore = f.explore_links || [];
  const company = f.company_links || [];
  const socials = [["instagram", Instagram], ["facebook", Facebook], ["twitter", Twitter]];
  return (
    <footer className="bg-navy text-cream/70 mt-20" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <img src={logoLight} alt="Begum's Biryani Secret" className="h-16 w-auto mb-4" />
          <p className="italic font-serif text-gold text-lg">{f.tagline || "Royal Flavours. Timeless Tradition."}</p>
          <p className="text-sm mt-3 leading-relaxed">{f.description}</p>
          <div className="flex gap-3 mt-5">
            {socials.map(([key, Icon]) => (
              <a key={key} href={f[key] || "#"} target="_blank" rel="noreferrer" data-testid={`footer-social-${key}`} className="w-9 h-9 rounded-full border border-cream/20 flex items-center justify-center hover:border-gold hover:text-gold transition-colors"><Icon size={16} /></a>
            ))}
          </div>
        </div>
        <div>
          <h4 className="overline text-gold mb-4">Explore</h4>
          <ul className="space-y-2.5 text-sm">
            {explore.map((l, i) => (
              <li key={i}><Link to={l.to} className="hover:text-gold transition-colors">{l.label}</Link></li>
            ))}
          </ul>
        </div>
        <div>
          <h4 className="overline text-gold mb-4">Company</h4>
          <ul className="space-y-2.5 text-sm">
            {company.map((l, i) => (
              <li key={i}><Link to={l.to} className="hover:text-gold transition-colors">{l.label}</Link></li>
            ))}
          </ul>
          <div className="flex flex-wrap gap-2 mt-4">
            <Link to="/admin/login" data-testid="footer-admin-panel" className="inline-flex items-center gap-1.5 text-xs text-cream/60 border border-cream/15 rounded-full px-3 py-1.5 hover:border-gold hover:text-gold transition-colors"><ShieldCheck size={13} /> Admin Panel</Link>
            <Link to="/kitchen/login" data-testid="footer-kitchen-staff" className="inline-flex items-center gap-1.5 text-xs text-cream/60 border border-cream/15 rounded-full px-3 py-1.5 hover:border-gold hover:text-gold transition-colors"><ChefHat size={13} /> Kitchen Staff</Link>
          </div>
        </div>
        <div>
          <h4 className="overline text-gold mb-4">Reach Us</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex gap-2"><MapPin size={16} className="text-gold shrink-0" /> {f.address || "Hazratganj, Lucknow, India"}</li>
            <li className="flex gap-2"><Phone size={16} className="text-gold shrink-0" /> <a href={`tel:${(f.phone || "+919000000000").replace(/[^0-9+]/g, "")}`} onClick={() => trackPhoneClick()} data-testid="footer-phone-link" className="hover:text-gold transition-colors">{f.phone || "+91 90000 00000"}</a></li>
            <li className="flex gap-2"><Mail size={16} className="text-gold shrink-0" /> {f.email || "hello@begumsbiryani.com"}</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-cream/10 py-5 text-center text-xs text-cream/50">© {new Date().getFullYear()} Begum's Biryani Secrets. All rights reserved.</div>
    </footer>
  );
}
